import React, { Component } from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import Tiered from './Tiered';
import Fixed from './Fixed';
import Company from './Company';


const styles = theme => ({
  root: {
  }
});

class LeadFilters extends Component {
  renderSelectedView = (selectedView) => {
      switch(selectedView){
        case 'fixed':
          return <Fixed {...this.props} />
        case 'company':
          return <Company {...this.props} />
        case 'carte':
          return <Tiered {...this.props} />
        default:
          return null
      }
  }
  render() {
 
    const { classes, priceMapType } = this.props;

    return this.renderSelectedView(priceMapType)
    
  }
}

LeadFilters.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeadFilters);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/index.js